import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { catchError, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { PinManagerService } from 'src/app/services/pin-manager.service';
import { Database, ref, push, set, serverTimestamp } from '@angular/fire/database';

@Component({
    selector: 'app-convert-pin',
    templateUrl: './convert-pin.component.html',
    styleUrls: ['./convert-pin.component.css'],
    standalone: false
})
export class ConvertPinComponent implements OnInit {

  pinId:number = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public convertPinDialog: MatDialogRef<ConvertPinComponent>,
      private pinManagerService: PinManagerService,
      public nav: NavBarComponent,
      private db: Database,
  ) {
  }
  ngOnInit(): void {
    if(this.data){
      this.pinId = this.data.pinId;
     }
  }
  close(): void {
    this.convertPinDialog.close({"option": "cancel"});
  }

  covertMarkerPinToVc(){
    this.nav.toggleLoading(true);
 
      this.convertPinDialog.close({"option": "convert"});

      this.pinManagerService.convertMarkerToVcPinById(this.pinId).pipe(
        catchError(error => {
          console.error(error);
          return throwError(() => error);
        })
    ).subscribe((result) => {
      this.convertPinDialog.close({"option": "convert"});
      this.createInspection(result.description, result);
      this.nav.toggleLoading(false);
    });
  
    }


    createInspection(desc, marker) {
      const dbRef = ref(this.db, 'inspections/');
      push(dbRef).then(newRef => {
          let newKey = newRef.key;
          let firebaseTimestamp = serverTimestamp();
          // let dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');
  
          let inspection = {
              description: desc,
              farmName: this.data.pinObj.farm,
              fieldName: this.data.pinObj.field,
              key: newKey,
              lastUpdated: firebaseTimestamp,
              latitude: String(marker.lat),
              longitude: String(marker.lng),
              sender: String(marker.userId),
              tenantId: String(marker.tenantId)
          };
          set(newRef, inspection);
      });
  }


}
